import PartnerForm from './partner_form';
export default PartnerForm;
